import PropTypes from 'prop-types'
import styled from 'styled-components'

import TableRow from 'components/Shared/TableNew/TableRow'

export const StyledTableFormRow = styled(TableRow)`
  height: ${props => props.height}px;
`

const TableFormRow = ({ children, className, height = 48 }) => {
  return (
    <StyledTableFormRow className={className} height={height}>
      {children}
    </StyledTableFormRow>
  )
}

TableFormRow.propTypes = {
  children: PropTypes.node,
  height: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
}

export default TableFormRow
